import { Amplify } from 'aws-amplify'
import { env } from './env'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: env.VITE_COGNITO_APP_CLIENT_ID,
    },
  },
})
